<div [ngClass]="{'btn-group btn-group-sm me-1': showOptions}" *transloco="let t; read: 'ime.manufacturing.manufacturing-graph-modal'">
  <button type="button" class="btn btn-sm btn-outline-primary" (click)="showGraph.emit()">
    <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#fork'">
    </svg>
    {{title}}
  </button>
  <div *ngIf="showOptions" class="btn-group btn-group-sm" ngbDropdown role="group" aria-label="Button group with nested dropdown">
    <button type="button" class="btn btn-sm btn-outline-primary dropdown-toggle-split" ngbDropdownToggle></button>
    <div class="dropdown-menu" ngbDropdownMenu>
      <button ngbDropdownItem (click)="shopGraphOptions()">{{t('Options')}}</button>
      <button ngbDropdownItem *ngIf="showGraphBuilderButton" (click)="showGraphBuilder.emit()">{{t('Graph builder')}}</button>
    </div>
  </div>
</div>
